import { dataFrom } from '@zyno-io/openapi-client-codegen';
import { jwtDecode } from 'jwt-decode';

import { IdentityApi, type IIdentity } from '@/generated/openapi-client';

class AuthService extends EventTarget {
    activeJwt: string | null = null;
    activeJwtExp: number | null = null;
    activeUser?: IIdentity;

    constructor() {
        super();
        this.loadStoredJwt();
    }

    private loadStoredJwt() {
        const ssJwt = localStorage.getItem('c2c:auth:sessionJwt');
        if (!ssJwt) return;

        const ssJwtExp = parseInt(localStorage.getItem('c2c:auth:sessionJwtExp')!);
        if (ssJwtExp <= Date.now()) {
            return this.clearSession();
        }

        this.activeJwt = ssJwt;
        this.activeJwtExp = ssJwtExp;
    }

    async checkSession() {
        if (!this.activeJwt) return;
        this.activeUser = dataFrom(await IdentityApi.getIdentityGetIdentity());
    }

    setJwt(jwt: string) {
        try {
            const decoded = jwtDecode(jwt);
            this.activeJwt = jwt;
            this.activeJwtExp = decoded.exp! * 1000;
            localStorage.setItem('c2c:auth:sessionJwt', jwt);
            localStorage.setItem('c2c:auth:sessionJwtExp', this.activeJwtExp.toString());
        } catch {
            this.clearSession();
        }
    }

    clearSession() {
        localStorage.removeItem('c2c:auth:sessionJwt');
        localStorage.removeItem('c2c:auth:sessionJwtExp');
        this.activeJwt = null;
        this.activeJwtExp = null;
        this.dispatchEvent(new Event('auth:cleared'));
    }

    // getLoginUrl(email: string) {
    //     return `https://auth.zynoapi.net/proxy-oidc/start?email=${encodeURIComponent(email)}&returnUrl=${encodeURIComponent(location.href)}`;
    // }
}

export const Auth = new AuthService();
